"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LockIcon = function LockIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "16px", height: "18px", viewBox: "0 0 11 13", className: "quiver-lock-icon" },
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-114.000000, -181.000000)" },
        _react2.default.createElement(
          "g",
          null,
          _react2.default.createElement(
            "g",
            { transform: "translate(114.000000, 180.000000)" },
            _react2.default.createElement("path", {
              d: "M5.5,1 C3.47416667,1 1.83333333,2.6228022 1.83333333,\n              4.62637363 L1.83333333,6.43956044 L0,6.43956044 L0,13.6923077 L11,\n              13.6923077 L11,6.43956044 L9.16666667,6.43956044 L9.16666667,\n              4.62637363 C9.16666667,2.6228022 7.52583333,1 5.5,1 L5.5,\n              1 Z M5.5,2.81318681 C6.59083333,2.81318681 7.33333333,3.54752747 7.33333333,\n              4.62637363 L7.33333333,6.43956044 L3.66666667,6.43956044 L3.66666667,\n              4.62637363 C3.66666667,3.54752747 4.40916667,2.81318681 5.5,2.81318681 Z M4.58333333,\n              8.25274725 L6.41666667,8.25274725 L6.41666667,11.8791209 L4.58333333,\n              11.8791209 L4.58333333,8.25274725 Z"
            })
          )
        )
      )
    )
  );
};

exports.default = LockIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/LockIcon/LockIcon.js
// module id = 602
// module chunks = 11